module.exports = __webpack_public_path__ + "static/media/application-insights.d076bd4e.svg";